import React from 'react'

import { Box, Grid } from '@mui/material'
import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const ImportList = ({ onRowClick }) => {
  return (
    <Box>
      <Grid container justifyContent='center'>
        <Grid size={11}>
          <SearchFrame
            model_name={'list'}
            sort={['createdAt DESC']}
            populate={['commercial_package']}
            allowCreate={false}
            default_limit={25}
          >
            <SearchForm submitOnMount disableButton>
              <FormContent><Form /></FormContent>
            </SearchForm>
            <SearchTable onRowClick={onRowClick}>
              <TableHeader><Header /></TableHeader>
              <TableRow><Row /></TableRow>
            </SearchTable>
          </SearchFrame>
        </Grid>
      </Grid >
    </Box>
  );
}

export default React.memo(ImportList)
